import Axios from "axios";
import { getSession } from "next-auth/react";
import { apiBaseUrl } from "../utils/constants";
import { notifySessionExpired } from "./sessionEvents";
// Custom error class to identify session expiration errors
export class SessionExpiredError extends Error {
    constructor(){
        super("Session expired");
        this.name = "SessionExpiredError";
    }
}
const axios = Axios.create({
    baseURL: apiBaseUrl
});
axios.interceptors.request.use(async function(config) {
    const session = await getSession();
    if (session) config.headers.Authorization = "Bearer ".concat(session.user.token);
    return config;
}, function(error) {
    return Promise.reject(error);
});
axios.interceptors.response.use(function(response) {
    return response;
}, async function(error) {
    var _response_data;
    const { response } = error;
    if ((response === null || response === void 0 ? void 0 : response.status) === 401 && ((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.message) === "jwt expired") {
        notifySessionExpired();
        // Return a custom error that can be identified by catch blocks
        // This prevents the generic error modal from showing
        return Promise.reject(new SessionExpiredError());
    }
    return Promise.reject(error);
});
export default axios;
